import { useSelector } from 'react-redux';
import {
  getCredentialsForGroup,
  getCredentialsListing,
} from 'js/reducers/credentialsGroups/selectors';
import useCredentials from 'new/state/credentials/repository/useCredentials';
import { Credential } from '@nexla/@types';

export default function useCredentialsGroup(data: any, connectionInfo: any) {
  const { getAvailableCredentialsOfType } = useCredentials();
  const connectionType = connectionInfo?.key;
  const allCredentials: Credential[] =
    useSelector((state: any) => getCredentialsForGroup(state, data?.id)) || [];

  const availableCredentialsOfType: Credential[] = getAvailableCredentialsOfType(
    connectionType,
    allCredentials,
  );

  const credentialsListing: Credential[] = useSelector(getCredentialsListing);

  return {
    availableCredentialsOfType,
    allCredentials,
    credentialsListing,
  };
}
